import type { Site } from "@datadog/browser-core";
import type { Logger } from "@datadog/browser-logs";

import { datadogLogs } from "@datadog/browser-logs";
import { acceptedService } from "vanilla-cookieconsent";

import type { CookieService } from "@/src/infrastructure/cookie-consent/CookieService";

import { CookieCategory } from "@/src/infrastructure/cookie-consent/CookieCategory";

export const datadogCookie: CookieService = {
  name: "Datadog",
  service: {
    cookies: [{ name: "_dd_s" }],
    label: "<strong>Datadog</strong> : suivi des erreurs techniques",
    onAccept: (): void => {
      datadogLogs.setTrackingConsent("granted");
    },
    onReject: (): void => {
      datadogLogs.setTrackingConsent("not-granted");
    },
  },
};

// https://docs.datadoghq.com/fr/logs/log_collection/javascript/
const datadogClientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
const datadogSite = process.env.NEXT_PUBLIC_DATADOG_SITE;
const datadogEnabled =
  datadogClientToken && datadogSite && typeof window !== "undefined";

if (datadogEnabled) {
  datadogLogs.init({
    clientToken: datadogClientToken,
    forwardConsoleLogs: ["warn", "error"],
    forwardReports: "all",
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
    site: datadogSite as Site,
    trackingConsent: acceptedService(
      datadogCookie.name,
      CookieCategory.ANALYTICS,
    )
      ? "granted"
      : "not-granted",
  });
}

export function Datadog(): null {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}

export const logger: Pick<Logger, "debug" | "error" | "info" | "warn"> =
  datadogEnabled ? datadogLogs.logger : console;
